// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d54e0528","977":"4c6b8575"}[chunkId] + ".chunk.js";
};